import * as actionType from "../constants";
import * as commonData from "../Common";

export const columnOrdering = (inputs) => async (dispatch) => {
  const url = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${url}/sequence`, {
      method: "post",
      body: JSON.stringify(inputs),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      dispatch({
        type: actionType.SEQUENCE_DONE,
        payload: { data: rdata.data, message: "success" },
      });
    }
  } catch (error) {
    console.log("all erro", error);
  }
};
